<template>
  <v-container fluid class="px-8">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <base-material-card inline icon="mdi-compare" color="primary" class="ml-0 px-5 py-4">
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">
            {{ title }}
          </div>
        </template>
        <v-form class="pt-5">
          <parametros ref="parametrosREF" :testesValidacaoItems="testesValidacaoItems" />
          <v-row>
            <v-col />
            <v-col cols="12" md="6">
              <v-btn
                id="btn-save-validador-laudos"
                color="success"
                min-width="100"
                style="float: right"
                class="mr-0 mt-5"
                :disabled="invalid"
                :loading="loading"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>

<script>
  import ValidadorLaudosService from '@/services/ValidadorLaudosService';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      Parametros: () => import('@/components/validadorLaudos/Parametros.vue')
    },
    mixins: [dateFormatterMixins, tourMixins],

    data: () => ({
      loading: false,
      testesValidacaoItems: [],
      arrTour: [
        {
          element: '#titulo-validador-laudos',
          intro: 'Aqui você poderá inserir um nome para sua validação de laudos.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#btn-save-validador-laudos',
          intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar sua validação de laudos.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    }),

    computed: {
      title() {
        return this.$route.params.id ? 'Editando Validação de Laudos' : 'Criar Validação de Laudos';
      }
    },

    created() {},

    mounted() {
      this.$store.dispatch('clearValidadorLaudos');
      if (this.$route.params.id) this.getById(this.$route.params.id);
      this.iniciarTourPagina();
    },

    methods: {
      getById(id) {
        ValidadorLaudosService.getById(id)
          .then((response) => {
            this.setDataInVuex(response.data.data);
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar validação de laudos.', '', {
              position: 'topRight'
            });
          });
      },

      salvar() {
        const data = this.$refs.parametrosREF.exportData();
        this.loading = true;

        ValidadorLaudosService.salvar(data, data.id)
          .then(() => {
            this.$toast.success('Validação de Laudos salva com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Validador de Laudos Histórico' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar validação de laudos.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },

      setDataInVuex(item) {
        this.$store.dispatch('setValidadorLaudos', {
          titulo: item.titulo,
          arquivoBaseExterna: item.arquivo_base_externa_id
            ? {
                id: item.arquivo_base_externa_id,
                fileObj: item.arquivo_base_externa
                  ? new File([''], item.arquivo_base_externa.arquivo, {
                      type: 'text/csv'
                    })
                  : undefined,
                delimitador: item.arquivo_base_externa_delimitador,
                involucro: item.arquivo_base_externa_involucro,
                escape: item.arquivo_base_externa_escape
              }
            : undefined,
          simulacaoLaudoIncremental: item.simulacao_laudo_incremental_id
            ? {
                id: item.simulacao_laudo_incremental.id,
                nome: item.simulacao_laudo_incremental.titulo
              }
            : undefined,
          parametros: JSON.parse(item.parametros)
        });

        this.$forceUpdate();
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>
